import { DataGrid, DataGridColumn, DataGridRef } from '@cimplico/components';
import { Ref, useState } from 'react';
import { ROW_SIZES } from '../../constants';
import { useProcedureTemplates } from '../../queries/use-procedure-templates';
import { ProcedureTemplateOverview } from '../../types/procedure';
import ProcedureTemplateRow from './ProcedureTemplatesRow';

const columns: DataGridColumn[] = [
    {
        header: 'Name',
        alignment: 'left',
        width: '1fr',
    },
    {
        header: 'Procedures',
        alignment: 'center',
        width: '1fr',
    },
    {
        header: 'Created By',
        alignment: 'left',
        width: '1fr',
    },
    {
        header: 'Created At',
        alignment: 'left',
        width: '1fr',
    },
];

type ProcedureTemplatesTableProps = {
    onSelect?: (procedureTemplates: ProcedureTemplateOverview[]) => void;
    tableRef: Ref<DataGridRef> | null;
    sort?: string;
};

function ProcedureTemplatesTable({ onSelect, tableRef, sort = '' }: ProcedureTemplatesTableProps): JSX.Element {
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(ROW_SIZES[0]);

    const procedureTemplatesQuery = useProcedureTemplates({ search: '', sort });

    function selectTemplates(ids: string[]): void {
        const selectedTemplates = procedureTemplates.filter((pt) => ids.includes(pt.id)) ?? [];
        onSelect && onSelect(selectedTemplates);
    }

    if (procedureTemplatesQuery.isLoading) {
        return <></>;
    }
    if (procedureTemplatesQuery.isError || !procedureTemplatesQuery.isSuccess) {
        return <p>Error!</p>;
    }

    const { procedureTemplates, totalItems } = procedureTemplatesQuery.data;

    return (
        <div>
            <DataGrid
                ref={tableRef}
                columns={columns}
                rowSizes={ROW_SIZES}
                totalRows={totalItems}
                onPageChange={setPage}
                onRowSizeChange={setLimit}
                onSelect={selectTemplates}
                isLoading={procedureTemplatesQuery.isFetching}
                emptyMessage="Could not find any procedure templates."
            >
                {procedureTemplates.map((pt, idx) => {
                    return <ProcedureTemplateRow id={pt.id} key={idx} procedureTemplate={pt} />;
                })}
            </DataGrid>
        </div>
    );
}

export default ProcedureTemplatesTable;
